// extracted by css-extract-rspack-plugin
export default {"wrapper":"Overview-module__wrapper__LkWY2","content":"Overview-module__content__AFUQ4","layout":"Overview-module__layout__LADQa","panel":"Overview-module__panel__vD65x"};